import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card } from 'antd';
import moment from 'moment-timezone';
import dayjs from 'dayjs';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts';
import './analytics.css';


import {
        inspectionTimeUpdate,
        getInverterData
} from '../../modules/analytics';


class InvertorsPower extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			loadingStationId: true
		 }
	}


	async componentDidMount() {
                const userStationList = this.props.userStationList || [];
                const inspectionTime = this.props.inspectionTime || {};
                if (userStationList.length && !inspectionTime.stationId) {
                        const next = { ...inspectionTime, stationId: userStationList[0].stationId };
                        await this.props.inspectionTimeUpdate(next);
                }
		this.getInverterData();
		this.setState({ loadingStationId: false});
	}

	async componentDidUpdate(prevProps) {
		const { inspectionTime } = this.props;
		if(JSON.stringify(inspectionTime) !== JSON.stringify(prevProps.inspectionTime)){
			this.getInverterData();
		}
	}

	getInverterData = async () => {
		const inspectionTime = this.props.inspectionTime || {};
		this.setState({ loading: true});
		if (inspectionTime.stationId) {
                        const dateStr = inspectionTime.date
                          ? inspectionTime.date.toString().substr(0,10)
                          : '';
                        await this.props.getInverterData(`stationId=${inspectionTime.stationId}&date=${dateStr}&range=${inspectionTime.range || 'd'}`);
		}
		this.setState({ loading: false});
	}


	render() {
		const { loading } = this.state;
                const stations = Array.isArray(this.props.userStationList)
                  ? this.props.userStationList
                  : [];
                const stationInfo = this.props.inspectionTime.stationInfo || stations.find(i => i.stationId === this.props.inspectionTime.stationId) || {};
                const data = Array.isArray(this.props.inverterData)
                  ? this.props.inverterData
		  : [];
		const { inspectionTime } = this.props;

		const option = {
		  tooltip: {
			trigger: 'axis',
			axisPointer: {
			  type: 'line'
			},
                        formatter: function (data) {
                                return `Energy Output of Station ${stationInfo.stationName || ''}: ${data[0].data} kWh<br>
                                ${moment(data[0].axisValue).format("YYYY-MMM-DD HH:mm")}
                                `
                        },
		  },
		  legend: {
			icon: 'roundRect',
			itemWidth: 30,
			itemHeight: 6,
                        data: ['Generated Energy'],
			textStyle: {
			  color: '#888',
			  fontSize: 14
			},
			bottom: 10,
			left: 'center'
		  },
		  xAxis: [
			{
			  type: 'category',
			  axisTick: { show: false },
			  axisLine: { lineStyle: { color: '#888' } },
			  data: data.map(d=>d.Timestamp),
			  axisLabel: {
				formatter: function (timestamp) {
					if(inspectionTime.range === 'd'){
						return moment(timestamp).format("HH:mm");
					}else if(inspectionTime.range === 'w'){
						return moment(timestamp).format("MMM-DD HH:mm");
					}else if(inspectionTime.range === 'y'){
						return moment(timestamp).format("MMM YYYY");
					}else{
						return moment(timestamp).format("MMM-DD");
					}
				}
				}
			}
		  ],
		  yAxis: [
			{
			  type: 'value',
                          axisLabel: {
                                formatter: function(value) {
                                  return value + ' kW';
                                },
				color: '#888',
				fontSize: 12,
			  },
			  axisLine: { lineStyle: { color: '#888' } },
			  splitLine: {
				lineStyle: { color: '#EEE' }
			  }
			},
			{
			  type: 'value',
			  position: 'right',
			  axisLabel: {
				formatter: '{value}%',
				color: '#888',
				fontSize: 12,
			  },
			  axisLine: { show: true, lineStyle: { color: '#888' } },
			  splitLine: { show: false }
			}
		  ],
		  series: [
			{
                          name: 'Generated Energy',
			  type: 'line',
			  smooth: true,
			  showSymbol: false,
			  areaStyle: {
				color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
				  { offset: 0, color: 'rgba(47, 137, 61, 0.5)' },
				  { offset: 1, color: 'rgba(47, 137, 61, 0)' }
				])
			  },
			  color: '#00B855',
			  lineStyle: { color: '#00B855', width: 1 },
			  emphasis: { focus: 'series' },
                          data: data.map(d => {
                                const value = Number(d.energyKWh);
                                if (Number.isNaN(value)) {
                                        return 0;
                                }
                                return Number(value.toFixed(3));
                          }),
			}
		  ],
		};

		return (
				<ReactECharts
					style={{ height: 480, width: '100%' }}
					option={option}
					notMerge
					showLoading={loading}
					loadingOption={{ color: "#00B855" }}
				/>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
        userStationList: state.analytics.userStationList,
        inverterData: state.analytics.inverterData,
	inspectionTime: state.analytics.inspectionTime
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			inspectionTimeUpdate,
                        getInverterData
                },
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(InvertorsPower);
